export default [
    {
      key: "empresa_info",
      label: "EMPRESA",
      visible: true,
      thStyle: "width: 25%",
    },
    {
      key: "logo",
      label: "LOGO",
      visible: true,
      thClass: "text-center",
      tdClass: "text-center",
      thStyle: "width: 10%",
    },
    {
      key: "direccion",
      label: "DIRECCIÓN",
      visible: true,
      thStyle: "width: 15%",
    },
    {
      key: "telefono",
      label: "TELÉFONO",
      visible: true,
      tdClass: "text-center",
      thStyle: "width: 10%",
    },
    {
      key: "correo",
      label: "CORREO",
      visible: true,
      thStyle: "width: 15%",
    },
    {
      key: "representante_legal",
      label: "REPRESENTANTE LEGAL",
      visible: true,
      thStyle: "width: 10%",
    },
    {
      key: "estado",
      label: "ESTADO",
      visible: true,
      thClass: "text-center",
      tdClass: "text-center",
      thStyle: "width: 7.5%",
    },
    {
      key: "id",
      label: "ACCIONES",
      visible: true,
      thClass: "text-center",
      tdClass: "text-center",
      thStyle: "width: 7.5%",
    },
  ];
  